import axios from 'axios'
import { Modal } from 'bootstrap'
import swal from 'sweetalert'

/**
 * Modals.
 *
 * Appends the Bootstrap modal backdrop to the app panel
 * so that it is under the modal itself.
 */
const modals = document.querySelectorAll('.modal')
modals.forEach(modal => {
  modal.addEventListener('show.bs.modal', e => {

    // Backdrop.
    const backdrop = document.createElement('div')
    backdrop.classList.add('modal-backdrop', 'fade', 'show')
    document.querySelector('#app-panel').appendChild(backdrop)

    // Button that triggered the modal.
    const button = e.relatedTarget

    if (button) {

      // For deals/offers, insert the additional data in the 
      // hidden form fields, and in the form headline.
      const dealName = button.getAttribute('data-bs-deal-name')
      const dealMeta = JSON.parse(button.getAttribute('data-bs-deal-meta'))

      if (dealName) {
        const dealNameInput = modal.querySelector('.deal-name-input input[type="hidden"]')
        const areaOfInterestInput = modal.querySelector('.area-of-interest-input input[type="hidden"]')
        const promoAppliedInput = modal.querySelector('.promo-applied-input input[type="hidden"]')

        const modalHeadline = modal.querySelector('.modal-headline')
        if (modalHeadline) {
          modalHeadline.innerHTML = dealName
        }

        if (dealNameInput) {
          dealNameInput.value = dealName
        } else {
          console.warn('.deal-name-input class not set on deal form input.')
        }

        if (areaOfInterestInput) {
          areaOfInterestInput.value = dealMeta.areaOfInterest
        } else {
          console.warn('.area-of-interest-input class not set on deal form input.')
        }

        if (promoAppliedInput) {
          promoAppliedInput.value = dealMeta.promoApplied
        } else {
          console.warn('.promo-applied-input class not set on deal form input.')
        }
      }
    }
  })

  // Remove the modal backdrop on modal close.
  modal.addEventListener('hidden.bs.modal', e => {
    const backdrop = document.querySelector('.modal-backdrop')
    backdrop.parentNode.removeChild(backdrop)
  })
})

// Look for links that target modals...
const modalLinks = document.querySelectorAll('a[href^="#"]')
modalLinks.forEach(modalLink => {
  modalLink.addEventListener('click', (e) => {
    e.preventDefault()

    const href = modalLink.getAttribute('href')
    if (href && href != '#' && href != '#/') {

      const target = document.querySelector(href)
      if (target && target.classList.contains('modal')) {
        const modal = Modal.getOrCreateInstance(target)
        modal.show()
      }
    }
  })
})

/**
 * Email sign up form.
 */
const emailSignupForms = document.querySelectorAll('.email-sign-up-form')
emailSignupForms.forEach(form =>  {
  form.addEventListener('submit', function(e) {
    e.preventDefault()

    const emailInput = form.querySelector('input[type="email"]')
    const emailAddress = emailInput.value
    const button = form.querySelector('button[type="submit"]')

    if (! /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress)) {
      swal('', 'Please enter a valid email address.', 'error')
      return
    }

    button.disabled = true

    const params = new URLSearchParams()
    params.append('action', 'email_sign_up')
    params.append('email', emailAddress)

    axios.post(ajaxurl, params)
      .then((response) => {
        emailInput.value = ''

        swal('', 'You have successfully subscribed.', 'success')

        // Close the containing modal?
        if (form.dataset.modal) {
          const modalEl = document.getElementById(form.dataset.modal)
          if (modalEl) {
            const modal = Modal.getInstance(modalEl)
            modal.hide()
          }
        }

        // Download a file?
        if (response.data && response.data.downloadUrl) {

          let req = new XMLHttpRequest()
          req.open("GET", response.data.downloadUrl, true)
          req.responseType = "blob"
          req.onreadystatechange = () => {
            if (req.readyState === 4 && req.status === 200) {

              // Download file
              let blob = new Blob([req.response])

              let a = document.createElement("a")
              document.body.appendChild(a)
              a.style = "display: none"

              let url = window.URL.createObjectURL(blob)
              a.href = url
              a.download = response.data.downloadName || 'Culligan.pdf'
              a.click()
            }
          }
          req.send()
        }

      })
      .catch((error) => {
        console.log(error)
        swal('', 'An unknown error occurred.', 'error')
      })
      .then(() =>  {
        button.disabled = false
      })
  })
})
